import React from "react";
import { connect } from "dva";
import { Button } from "antd";
import Container from "../../../../../../components/Container";
import ListPage from "../../../../../../components/ListPage";
import { getIndexDetail } from "../../../../../../services/activitySign/normStatistic";
import { GetQueryString } from "../../../../../../utils/utils";
import { url } from "../../../../../../services/service-utils";
import useRequest from "../../hooks/use-table-state";
import styles from "./index.less";

const { ListTable } = ListPage;

const IndexDetail = () => {
  const appId = GetQueryString("appId") || 40;
  const activityBizId = GetQueryString("activityBizId");
  const indexName = GetQueryString("indexName");
  const createUser = GetQueryString("createUser");
  const userName = GetQueryString("userName");

  const { pageInfo, list, loading, handlePaginationChange } = useRequest(
    getIndexDetail,
    {
      initParams: {
        page: 1,
        pageSize: 10,
        activityBizId,
        indexName,
        createUser
      }
    }
  );

  const columns = [
    {
      title: "日期",
      dataIndex: "gmtCreate",
      key: "gmtCreate",
      width: 330,
      fixed: "left"
    },
    {
      title: indexName || "-",
      dataIndex: "itemSum",
      key: "itemSum",
      width: 120,
      render: itemSum => itemSum || "-"
    }
  ];

  const containerProps = {
    breStates: 1,
    isPathParams: 1,
    defaultPadding: 1
  };

  const listPageProps = {
    spinProps: {
      spinning: loading
    }
  };

  const tableProps = {
    columns,
    list,
    pageInfo,
    onPageChange: handlePaginationChange
  };

  return (
    <Container {...containerProps}>
      <div className={styles.root}>
        <ListPage {...listPageProps}>
          <div className="buttonContainer">
            <Button
              type="primary"
              href={`${url.activitySign}/activity/item/download/exportPerson?activityBizId=${activityBizId}&createUser=${createUser}&indexName=${indexName}&userName=${userName}&appId=${appId}`}
            >
              导出
            </Button>
          </div>
          <ListTable {...tableProps} />
        </ListPage>
      </div>
    </Container>
  );
};

export default connect()(IndexDetail);
